// "Last active character" pointer. This is a UI/session preference — which
// save slot was active when the tab last closed — not domain data, so it
// lives in localStorage rather than the IndexedDB `characters` store (no
// DB_VERSION bump, no migration). On startup App reads it to auto-activate
// the last-used character; see active-character.ts for the write side.
//
// Every accessor is wrapped in try/catch: Safari private mode and
// storage-disabled environments throw on access, and a missing pointer must
// never break app boot.
//
// Phase 3 Step 10d-ux-polish.

const LAST_ACTIVE_KEY = 'renavora:lastActiveId';

/** Most recently activated character id, or null if unset/unavailable. */
export function readLastActiveId(): string | null {
  try {
    return globalThis.localStorage?.getItem(LAST_ACTIVE_KEY) ?? null;
  } catch {
    return null;
  }
}

/** Persist the active character id so the next boot can restore it. */
export function writeLastActiveId(id: string): void {
  try {
    globalThis.localStorage?.setItem(LAST_ACTIVE_KEY, id);
  } catch {
    // Storage unavailable (private mode / disabled) — restore silently degrades.
  }
}

/** Forget the pointer (on unload, or when the pointed-to record is gone). */
export function clearLastActiveId(): void {
  try {
    globalThis.localStorage?.removeItem(LAST_ACTIVE_KEY);
  } catch {
    // No-op: nothing to clear if storage is unavailable.
  }
}
